module.exports = __webpack_public_path__ + "img/ammiraglio 7 bagno.08e4d617.jpeg";